export default "__VITE_ASSET__8bce1ab1__"